import type { CSSProperties } from "react";
import { EDUCATION_PARTNERS } from "@/content/educationPartners";
import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./PartnersTicker.module.css";

const COPIES = 2;

export function PartnersTicker() {
  const { partnersTicker } = useMaestriaContent();
  const ariaLabel =
    partnersTicker?.ariaLabel ?? "Empresas que Eduardo e Lucas já transformaram com IA";
  const line1 = partnersTicker?.line1 ?? "EMPRESAS QUE EDUARDO E LUCAS";
  const line2 = partnersTicker?.line2 ?? "JÁ TRANSFORMARAM COM IA";

  return (
    <section
      className={styles.proof}
      aria-label={ariaLabel}
    >
      <div className={styles.content}>
        <p className={styles.label}>
          <span>{line1}</span>
          <strong>{line2}</strong>
        </p>

        <div className={styles.viewport}>
          <div className={styles.track}>
            {Array.from({ length: COPIES }, (_, copy) => (
              <ul key={copy} className={styles.group} aria-hidden={copy > 0 || undefined}>
                {EDUCATION_PARTNERS.map((partner) => (
                  <li key={partner.name} className={styles.item}>
                    <img
                      src={partner.logo}
                      alt={copy === 0 ? partner.name : ""}
                      width={partner.width}
                      height={partner.height}
                      loading="lazy"
                      className={styles.logo}
                      style={
                        {
                          "--logo-height": `${partner.height}px`,
                        } as CSSProperties
                      }
                    />
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
